import { Breadcrumb as AntdBreadcrumb } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import { useBreadcrumbs } from '../model/use-breadcrumbs'

const unclickableItems = ['/posts']

export const Breadcrumbs: React.FC = () => {
    const breadcrumbs = useBreadcrumbs()

    return (
        <AntdBreadcrumb
            style={{ margin: '16px 0' }}
            items={breadcrumbs}
            itemRender={(item) => {
                const href = item.href || ''

                return (
                    <Link
                        to={item.href || ''}
                        onClick={(e) => {
                            if (unclickableItems.includes(href)) e.preventDefault()
                        }}
                    >
                        {item.title}
                    </Link>
                )
            }}
        />
    )
}
